export default "__VITE_ASSET__C57xbzoK__"